import http from '../../http/common'

const resource = '/status'

export default {

	get: (payload) => http.get(`${resource}${payload}`)
}
